import React from 'react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
import { RadiantStar } from './ui/RadiantStar';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-24 pb-12" data-id="element-58">
      {/* Background with gradient and texture */}
      <div className="absolute inset-0 bg-gradient-to-b from-night-900 via-night-800 to-earth-900 z-0" data-id="element-59"></div>
      <div className="absolute inset-0 bg-grain opacity-20 z-0 mix-blend-overlay" data-id="element-60"></div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 w-full" data-id="element-61">
        {/* Centered Star above everything */}
        <div className="flex justify-center mb-6" data-id="element-62">
          <RadiantStar size={64} animate={true} data-id="element-63" />
        </div>

        {/* Top: Text + Photo side by side */}
        <div className="grid grid-cols-[1fr_auto] gap-6 sm:gap-10 lg:gap-14 items-center mb-10" data-id="element-64">
          {/* Left side - Text content */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 1,
          ease: 'easeOut'
        }} className="text-left" data-id="element-65">
            <motion.h1 initial={{
            opacity: 0,
            filter: 'blur(4px)'
          }} animate={{
            opacity: 1,
            filter: 'blur(0px)'
          }} transition={{
            duration: 1.2,
            delay: 0.3,
            ease: 'easeOut'
          }} className="font-serif text-3xl md:text-5xl lg:text-6xl leading-tight text-gold-400 mb-1 text-glow" data-id="element-66">
              Feeling overwhelmed?
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 1,
            delay: 0.8,
            ease: 'easeOut'
          }} className="font-serif text-lg md:text-2xl lg:text-3xl leading-snug text-cream-50 font-light" data-id="element-67">
              From stuck in expectations to living a life that finally feels
              like yours.
            </motion.p>
          </motion.div>

          {/* Right side - Portrait Photo */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.2,
          ease: 'easeOut'
        }} className="flex justify-end" data-id="element-68">
            <div className="relative" data-id="element-69">
              <div className="absolute -inset-2 bg-gold-400/15 rounded-2xl transform rotate-2" data-id="element-70"></div>
              <img src="https://cdn.magicpatterns.com/uploads/sjqk9147GGzZcR6Q2opMuU/ChatGPT_Image_26_mei_2026,_20_30_35.png" alt="Mark Vermeulen" className="relative rounded-2xl shadow-2xl w-[200px] sm:w-[260px] md:w-[320px] lg:w-[380px] object-contain border border-gold-400/20" data-id="element-71" />
            </div>
          </motion.div>
        </div>

        {/* Buttons below - centered */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 1.3,
        duration: 0.8
      }} className="relative z-20 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-5" data-id="element-72">
          <Button variant="primary" href="#contact" data-id="element-73">
            Book a Session
          </Button>
          <Button variant="outline" href="#offerings" data-id="element-74">
            Discover Group Journeys
          </Button>
        </motion.div>
      </div>

      {/* Bottom fade to blend with next section */}
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-earth-900 to-transparent z-10 pointer-events-none" data-id="element-75"></div>
    </section>;
}